import React from "react";
import ReportCenter from "../../components/Reports/ReportCenter.js";

const Reports = () => <ReportCenter />;

export default Reports;
